import React, { useEffect } from "react";
import AuthenticationService from "../Authentication/AuthenticationService";
import { Link, useNavigate } from "react-router-dom";
import {
  clientname,
  currentTenant,
  currentUser,
  financialyearend,
  financialyearstart,
  logo,
  roles,
  userid,
  theme,
  logoDimensions
} from "../Common/Credentials";
import { useIdleTimer } from "react-idle-timer";
import { Menu, MenuItem, Tooltip } from "@mui/material";
import NotificationServices from "../Notifications/NotificationServices";
import Swal from "sweetalert2";
import { appmaster, screens } from "../Common/Products";
import { appmasterid } from "../Common/Permissions";
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Bell, Maximize2, Search } from "lucide-react";
import moment from "moment";
import { AllScreens } from "../Data/AllScreens";

const Header = ({ InitialSetUp }) => {
  // const isUserLoggedIn = AuthenticationService.isUserLoggedIn();
  const navigate = useNavigate();
  const inputRef = React.useRef()

  const [showNotifications, setShowNotifications] = React.useState(false);

  const [isOpen, setIsOpen] = React.useState(false)
  const [searchTerm, setSearchTerm] = React.useState("")
  let [unread, UnRead] = React.useState(0);
  const [notifications, setNotifications] = React.useState([])
  // let [timerem,settimerem] = React.useState(30000)
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    if (userid === undefined || currentUser === undefined || !roles) {
      Swal.fire({
        title: "Session is Lost!",
        text: "Please login Back to resume",
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: '#152f5f',
      }).then(() =>
        navigate("/")
      )
      navigate("/")
    } else {

      NotificationServices.GetLastThreeandUnreadNotifications(currentTenant, userid)
        .then((res) => {
          UnRead(res.data.unread)
          setNotifications(res.data.notifications)
        }
        )
        .catch((e) => {
          if (e.response !== undefined) {
            if (e.response.data.error === "Unauthorized") {
              Swal.fire({
                title: "Session is Lost!",
                text: "Please login Back to resume",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: '#152f5f',
              }).then(() =>
                navigate("/")
              )
            }
          }
        });
    }
  }, [navigate, roles]);

  function logout() {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Logout?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: '#152f5f',
      cancelButtonText: "No",
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        if (currentUser && currentTenant) {
          AuthenticationService.logout(currentUser, currentTenant).then
            (() => {
              Swal.fire({
                title: "You are Logged Out Successfully",
                text: "",
                icon: "success",
                confirmButtonText: "Ok",
                confirmButtonColor: '#152f5f',
              }).then(() =>
                navigate("/")
              ).catch(() => navigate("/"))
              // AuthenticationService.logout(currentUser).then(() => {
              //   alert("You are Logged Out Successfully, Go Back to Login", usertoken);
              //   navigate("/");
              // });
            })
        } else {
          navigate("/")
        }
      }
    });

  }

  const handleToggle = () => {
    if (!isOpen) {
      setIsOpen(true);
      setTimeout(() => inputRef.current?.focus(), 150);
    }
  };

  const onSearch = (value) => {
    setSearchTerm(value)
  }

  const handleOnIdle = (event) => {
    AuthenticationService.logout(currentUser, currentTenant).then(() => {
      Swal.fire({
        title: "Session is Lost!",
        text: "Please login Back to resume",
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: '#152f5f',
      }).then(() =>
        navigate("/")
      )
      navigate("/")
    })
    //  props.navigate(`/`)
  };
  const handleOnActive = event => { }

  const handleOnAction = event => { }

  const GetUserInitialls = (name = "") => {
    const words = name.trim().split(/\s+/).filter(Boolean);

    if (words.length === 0) return "U";

    if (words.length === 1) return words[0][0].toUpperCase();

    return (words[0][0] + words[words.length - 1][0]).toUpperCase();

  }

  const { getRemainingTime } = useIdleTimer({
    // 1000 is milliseconds , 60 is seconds , 10 is min

    timeout: 1000 * 60 * 20,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500,
  });

  //   setInterval((e) => {
  //     if(Math.floor(getRemainingTime() / 1000)===0){}else{
  //     if(Math.floor(getRemainingTime() / 1000)<=185){
  //     Swal.fire({
  //       title: `Session will be lost in ${Math.floor(getRemainingTime() / 60000 ) + 1} min`,
  //       text: "",
  //       icon: "info",
  //       confirmButtonText: "Ok",
  //       confirmButtonColor:'#152f5f',
  //     })
  //     }
  //     }
  // }, 15000)



  const markAllRead = () => {
    NotificationServices.MarkAllasRead(currentTenant, userid).then(() => {
      NotificationServices.GetLastThreeandUnreadNotifications(currentTenant, userid)
        .then((res) => {
          UnRead(res.data.unread)
          setNotifications(res.data.notifications)
          setShowNotifications(false)
        })
    })
  }

  const escapeRegex = (string) => {
    if (!string) return '';
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  const highlightSearchText = (text, searchTerm) => {
    if (!searchTerm?.trim() || !text) return text;

    const rawText = String(text);
    const escapedSearchTerm = escapeRegex(searchTerm);

    if (escapedSearchTerm.length > 50) {
      return rawText;
    }

    try {
      const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
      const parts = rawText.split(regex);

      return parts.map((part, index) =>
        regex.test(part)
          ? React.createElement('mark', {
            key: index,
            className: 'tw-bg-blue-100 tw-px-0 tw-py-0 tw-rounded tw-text-blue-800 tw-font-semibold ',
          }, part)
          : part
      );
    } catch (error) {
      console.warn('Regex error in search:', error);
      return rawText;
    }
  }

  return (
    <nav className="header navbar sticky-top navbar-expand navbar-white navbar-light m-0 !tw-shadow-[0_8px_30px_rgba(0,0,0,0.015)]">
      <ul className="navbar-nav">
        {!InitialSetUp && <li className="automargin">
          <div className="nav-link" data-widget="pushmenu" role="button">
            <i className="fas fa-bars " />
          </div>
        </li>}

        {!InitialSetUp && <Link
          className="nav-link m-0 p-0 tw-flex"
          aria-current="page"
          to="/index"
        >
          <img
            src={logo}
            alt="Logo..."
            className="d-inline-block logoholder"
            style={{
              height: `${logoDimensions ? logoDimensions?.height : 60}px`,
              width: `${logoDimensions ? logoDimensions?.width : 60}px`
            }}
          />
        </Link>}

        <div className="text-dark pl-2 m-auto hidden-text tw-cursor-default">
          <b className="tw-font-extrabold tw-tracking-tight tw-text-slate-900 tw-text-base"><Tooltip title={currentTenant}>{clientname}</Tooltip></b>
          <p className="tw-my-0 tw-text-[10px] tw-text-slate-500 tw-font-medium">Financial Year: {financialyearstart?.substring(0, 4)}{financialyearstart?.substring(0, 4) !== financialyearend?.substring(0, 4) && `-${financialyearend?.substring(0, 4)}`}</p>
        </div>
      </ul>

      <ul className="navbar-nav ml-auto">

        {!InitialSetUp &&
          <div id="expanding-search-container" className="tw-relative ">
            <div
              id="expanding-search-bar"
              onClick={handleToggle}
              className={`tw-flex tw-items-center tw-gap-2.5 tw-cursor-pointer ${isOpen
                ? 'tw-w-48 sm:tw-w-64 md:tw-w-80 tw-px-3.5 tw-h-10 tw-bg-slate-50 tw-rounded-xl tw-border tw-border-slate-200/80 tw-transition-all tw-duration-300 tw-ease-in-out tw-shadow-inner tw-overflow-hidden'
                : 'tw-w-10 tw-h-10 tw-flex tw-justify-center hover:tw-bg-slate-100 tw-rounded-xl tw-transition-all tw-cursor-pointer '
                }`}
            >
              <Search
                size={18}
                className={`tw-shrink-0 tw-transition-colors tw-duration-250 ${isOpen ? 'tw-text-blue-600' : ' hover:tw-text-slate-800 tw-text-slate-400'
                  }`}
              />

              {isOpen && <><input
                ref={inputRef}
                id="global-search-input"
                type="text"
                placeholder="Search reports, SKUs..."
                value={searchTerm}
                onChange={(e) => onSearch(e.target.value)}
                onBlur={() => {
                  if (!searchTerm) {
                    setIsOpen(false);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Escape') {
                    onSearch('');
                    setIsOpen(false);
                  }
                }}
                onClick={(e) => e.stopPropagation()}
                style={{
                  width: isOpen ? '100%' : '0px',
                  opacity: isOpen ? 1 : 0,
                  pointerEvents: isOpen ? 'auto' : 'none'
                }}
                className="tw-bg-transparent tw-border-0 tw-text-sm tw-text-slate-700 tw-font-bold tw-outline-none tw-ring-0 tw-transition-all tw-duration-300"
              />

                <button
                  id="search-clear-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    onSearch('');
                    setIsOpen(false);
                  }}
                  className="tw-shrink-0 tw-text-slate-400 hover:tw-text-slate-650 tw-text-[10px] tw-font-extrabold tw-font-mono tw-px-1.5 tw-py-0.5 tw-bg-slate-200/60 tw-rounded-md tw-border tw-border-slate-300/30 tw-cursor-pointer"
                >
                  ESC
                </button>
              </>}
              {searchTerm && (
                <div className="tw-absolute tw-top-full tw-left-0 tw-mt-1 tw-w-full tw-bg-white tw-border tw-border-slate-200 tw-shadow-lg tw-rounded-md tw-py-2 tw-z-50">
                  <p className="tw-text-sm tw-text-slate-500 tw-px-4 tw-my-2">Search results for "<span className="tw-font-bold">{searchTerm}</span>"</p>
                  <ul className="tw-max-h-60 tw-overflow-y-auto">
                    {AllScreens.filter(s => s.label.toLowerCase().includes(searchTerm.toLowerCase())).map(s => (
                      <li key={s.path} className="tw-px-4 tw-py-2 tw-text-sm tw-text-slate-700 hover:tw-bg-slate-100 tw-cursor-pointer">
                        <Link to={s.path}>{highlightSearchText(s.label, searchTerm)}</Link>
                      </li>
                    ))}
                  </ul>
                </div>)}

            </div>
          </div>
        }

        {!InitialSetUp &&
          <button
            type="button"
            id="maximize-mode-btn"
            onClick={() => {
              if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen().catch(() => { });
              } else {
                document.exitFullscreen().catch(() => { });
              }
            }}
            className="tw-p-2.5 tw-text-slate-400 hover:tw-text-slate-800 hover:tw-bg-slate-100 tw-rounded-xl tw-transition-all tw-cursor-pointer tw-hidden sm:tw-block tw-ring-0 focus:tw-outline-none tw-shadow-none"
            title="Fullscreen Mode"
          >
            <Maximize2 size={18} />
          </button>}
        {/* {!InitialSetUp && <li className="automargin">
          <Link
            to="/notifications"
          >
            <IconButton
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
            <Avatar sx={{ width: 32, height: 32,overflow:'visible' }} className="text-newcolor bg-transperent" >
            {unread === 0 ? (<i className="far fa-bell" style={{fontSize:'x-large'}} />)
            :<>
                    <i
                      className="far fa-bell automargin textColour shakeanimation"
                  style={{ color: "#17a2b8",fontSize:'x-large',fontWeight:600 }}
                    />
                    <span className="badge rounded-circle navbar-badge">
                  {unread>100?99:unread}
                    </span>
                  </>}

              </Avatar>
            </IconButton>
          </Link>
        </li>} */}

        {!InitialSetUp && <div id="notification-bell-dropdown" className="tw-relative">
          <button
            id="notifications-indicator"
            onClick={() => setShowNotifications(!showNotifications)}
            className="tw-p-2.5 tw-text-slate-500 hover:tw-text-bllue-600 hover:tw-bg-blue-50 tw-rounded-xl tw-transition-all tw-relative tw-cursor-pointer tw-ring-0 focus:tw-outline-none"
          >
            <Bell size={22} />
            {unread && (unread > 0) ? (
              <span className={"tw-absolute tw-top-1.5 tw-right-1.5 tw-w-4 tw-h-4 " + (theme === "classic" ? "tw-bg-[#4d4d4d]" : "tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600") + " tw-text-white tw-text-[7px] tw-font-extrabold tw-flex tw-items-center tw-justify-center tw-rounded-full tw-ring-none tw-focus:ring-none tw-focus:outline-none"}>
                {unread > 99 ? "99+" : unread}
              </span>
            ) : null}
          </button>

          {showNotifications && (
            <div className="tw-absolute tw-right-0 tw-mt-3.5 tw-w-80 tw-bg-white tw-border tw-border-slate-200 tw-shadow-2xl tw-rounded-2xl tw-p-4 tw-z-50 tw-text-left scale-up-entry animate-fade-in">
              <div className="tw-flex tw-items-center tw-justify-between tw-pb-3 tw-border-b tw-border-slate-100">
                <span className="tw-font-bold tw-text-slate-800 tw-text-sm">
                  Notifications
                </span>

                <span className={"tw-text-[10px] tw-font-semibold tw-px-2 tw-py-0.5 tw-rounded-full tw-cursor-pointer " + (theme === "classic" ? " tw-text-[#4d4d4d] tw-bg-[#f8f0e7]" : " tw-text-blue-600 tw-bg-blue-50")} onClick={markAllRead}>
                  Mark all read
                </span>
              </div>

              <div className="tw-py-2.5 tw-space-y-3 tw-max-h-60 tw-overflow-y-auto">
                {notifications.map((n) => (
                  <div
                    key={n.id}
                    className="tw-flex tw-gap-2.5 tw-text-xs tw-p-2 hover:tw-bg-slate-50 tw-rounded-xl tw-transition-colors"
                  >
                    <div
                      className={`tw-w-2 tw-h-2 tw-rounded-full tw-mt-1.5 tw-shrink-0 ${n.notificationstatus === 0 ? 'tw-bg-blue-500' : 'tw-bg-slate-300'
                        }`}
                    />

                    <div className="tw-flex-1">
                      <p className="tw-font-bold tw-text-slate-700">{n.subject}</p>

                      <p className="tw-text-slate-500 tw-leading-normal tw-mt-0.5">
                        {n.content}
                      </p>

                      <span className="tw-text-[10px] tw-text-slate-400 tw-font-medium tw-block tw-mt-1">
                        {moment(n.createdAt).format("DD-MM-YYYY hh:mm A")}
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="tw-border-t tw-border-slate-100 tw-pt-2.5 tw-text-center">
                <Link className="tw-text-xs tw-font-semibold tw-text-blue-600 hover:tw-text-blue-700 tw-inline-block" to="/notifications">
                  View all
                </Link>
              </div>
            </div>
          )}
        </div>}

        {/* Notifications Dropdown Menu */}
        {/* <li className="nav-item dropdown">
          <a className="nav-link d-flex" data-toggle="dropdown" href="fake.url">
           
            <span className="avatar bg-white"><img src={userIcon} className="nav-icon" width="30" alt="user"/></span>
            <span className="m-0 pl-1 hidden-text">
              <h5 className="m-auto textColour">{currentUser}</h5>
              <p className="m-auto text-sm">{roles}</p>
            </span>
            <span className="badge badge-warning navbar-badge"></span>
          </a>
          <div className="dropdown-menu dropdown-menu-sm dropdown-menu-right pb-0" 
          style={{width: '-webkit-fill-available'}}>
           
            <div />
            
             {appmaster==="YES" && (appmasterid === "2" || appmasterid ==="3") && screens.includes("Admin Masters") ?
            <div className="dropdown-item">
              <Link className="textColour pr-2 py-2" to="/settings">
                <i className="fas fa-cog pr-2 py-2" /> Settings
              </Link>
            </div>
            :''}
            {appmaster==="YES" && (appmasterid === "2" || appmasterid ==="3") && screens.includes("Admin Masters")?
            <div className="dropdown-item">
              <Link className="textColour pr-2 py-2" to={{pathname: "/newusers"}} state ={ { id: -1, name: "New User" }}>
               <i className="fa fa-user-plus pr-2 py-2"></i> New User
              </Link>
            </div>
            :''}
            <div className="dropdown-item border-top">
              {
                <span
                  className="text-danger pr-2 py-2 cursorpointer"
                  onClick={() => logout()}
                >
                  <i className="fas fa-sign-out-alt pr-2 py-2" /> Logout
                </span>
              }
            </div>
          </div>
        </li> */}

        <li className="automargin">

          <div
            onClick={handleClick}
            className="tw-ml-2 tw-cursor-pointer"
          >
            {/* <Avatar sx={{ width: 32, height: 32 }} className="text-yellow bg-newcolor" >{GetUserInitialls(currentUser)}</Avatar> */}
            <div id="user-status-avatar-capsule" className="tw-flex tw-items-center tw-gap-2.5 tw-pl-2 tw-border-l tw-border-slate-200">
              <div className="tw-relative">
                <div className={"tw-w-10 tw-h-10 tw-rounded-full " + (theme === "classic" ? "tw-bg-[#4d4d4d]" : "tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600") + " tw-border-2 tw-border-indigo-200 tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-black tw-text-purple-100 tw-shadow-sm"}>
                  {GetUserInitialls(currentUser)}
                </div>
                {/* Green dot active indicator exactly as in uploaded graphic */}
                <span className="tw-absolute tw-bottom-0 tw-right-0 tw-w-3 tw-h-3 tw-bg-emerald-500 tw-rounded-full tw-ring-2 tw-ring-white"></span>
              </div>
              <div className="tw-hidden md:tw-flex tw-flex-col tw-text-left">
                <span className="tw-text-xs tw-font-bold tw-text-slate-800 hover:text-blue-600 tw-cursor-pointer">{currentUser}</span>
                <span className="tw-text-[10px] tw-text-emerald-600 tw-font-semibold tw-uppercase tw-tracking-wider">{roles}</span>
              </div>
            </div>
          </div>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '&:before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            {/* <MenuItem> */}
            {/* <ListItemIcon>
            <PersonIcon fontSize="small" />
          </ListItemIcon> */}
            {/* <div>
                <div className="textColour">{currentUser}</div>
                <div className="text-xs">{roles}</div>
              </div> */}
            {/* </MenuItem> */}
            {/* <Divider /> */}

            <MenuItem style={{ cursor: "default", background: "#fff" }}>
              {appmaster === "YES" && (appmasterid === "2" || appmasterid === "3") && screens.includes("Admin Masters") && <>
                <ListItemIcon onClick={() => navigate({ pathname: "/newusers" }, { state: { id: -1, name: "New User" } })} style={{ cursor: "pointer" }} >
                  <Tooltip title="New User">
                    <PersonAdd fontSize="small" className="hover:tw-bg-slate-100 tw-rounded-full" />
                  </Tooltip>
                </ListItemIcon>
                <ListItemIcon onClick={() => navigate("/settings")} style={{ cursor: "pointer" }}>
                  <Tooltip title="Settings">
                    <Settings fontSize="small" className="hover:tw-bg-slate-100 tw-rounded-full" />
                  </Tooltip>
                </ListItemIcon>
              </>}
              <ListItemIcon onClick={() => logout()} style={{ cursor: "pointer" }}>
                <Tooltip title="Logout">
                  <Logout fontSize="small" className="hover:tw-bg-slate-100 tw-rounded-full" />
                </Tooltip>
              </ListItemIcon>
            </MenuItem>
            {/* {appmaster==="YES" && (appmasterid === "2" || appmasterid ==="3") && screens.includes("Admin Masters")?
        <MenuItem onClick={()=>navigate("/settings")}>
                <ListItemIcon>
                  <Settings fontSize="small" />
                </ListItemIcon>
                Settings
              </MenuItem>
        :""}
            <MenuItem onClick={() => logout()}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem> */}
          </Menu>
        </li>
      </ul>

    </nav>
  );
}
export default Header